import { createReducer } from 'typesafe-actions';
import { ADD_COUPON_EVENT, CHANGE_RIGHT_PANEL_TAB } from '../actions';

export type rightPanelTabType = 'coupon' | 'steps';

export const rightPanelTab = createReducer<rightPanelTabType>('coupon')
    .handleAction(CHANGE_RIGHT_PANEL_TAB, (state, action) => action.payload)
    .handleAction(ADD_COUPON_EVENT, () => 'coupon');